<div class="widget-container">
  <a class="widget-btn btn btn--default"
     type="button"
     [style.background-color]="themeColor"
     [href]="buttonUrl"
     target="_blank">
    {{ text }}
  </a>
  <div class="widget-caption">
    <img
      ngSrc="/assets/images/iq-logo.png"
      alt="myhomeIQ logo"
      width="23"
      height="16"
    />
    <span class="widget-caption-text">Powered by <i>my</i>homeIQ</span>
  </div>
</div>
